//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SaldoRepresentante from './SaldoRepresentante';
import { getMoney } from '../../../../../../common/functions/helpers';

export default {
  props: {
    saldoRepresentante: {
      type: SaldoRepresentante,
      default: new SaldoRepresentante({}),
    },
    carregando: Boolean,
  },
  methods: {
    getMoney,
    getObjSaldo() {
      return this.saldoRepresentante || {};
    },
  },
};




// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/orcamento/BoxValoresRepresentante.vue?vue&type=script&lang=js&